import Vue from 'vue';
import VueRouter from 'vue-router';
// 使用插件
Vue.use(VueRouter)

let originPush = VueRouter.prototype.push
let originReplace = VueRouter.prototype.replace
// 重写push\replace方法
VueRouter.prototype.push = function (location, resolve, reject) {
  if (resolve && reject) {
    originPush.call(this, location, resolve, reject)
  } else {
    originPush.call(this, location, () => { }, () => { })
  }
}
VueRouter.prototype.replace = function (location, resolve, reject) {
  if (resolve && reject) {
    originReplace.call(this, location, resolve, reject)
  } else {
    originReplace.call(this, location, () => { }, () => { })
  }
}
export const publicRoutes = [
  //  {
  //   path:'/',
  //   name:'TicketHomePage',
  // },
  {
    path: '/error',
    name: 'Error',
    redirect: '/error/404',
    component: () => import('@/views/layout/error.vue'),
    meta: { title: '错误页'},
    children: [
      {
        path: '/error/404',
        name: '404',
        component: () => import('@/views/error-page/403.vue'),
        meta: { title: '403'},
      },
    ]
  },
];

export const asyncRoutes = []

const router = new VueRouter({
  mode: 'history',
  routes: publicRoutes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router